import { render, staticRenderFns } from "./tongguo.vue?vue&type=template&id=0b89177a&scoped=true&"
import script from "./tongguo.vue?vue&type=script&lang=js&"
export * from "./tongguo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89177a",
  null
  
)

export default component.exports